module.exports = __webpack_public_path__ + "img/iso-murs.2b4665f3.svg";